import React, { useState, useEffect } from "react";
import { joinLinkApi } from "../api";
import "./AdminJoinLink.css";

const AdminJoinLink = () => {
  const [link, setLink] = useState("");
  const [newLink, setNewLink] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLink();
  }, []);

  const fetchLink = async () => {
    try {
      const res = await joinLinkApi.get();
      if (res.data?.link) setLink(res.data.link);
    } catch (err) {
      console.error("❌ Error fetching link:", err);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!newLink.trim()) return alert("Please enter a new link.");

    setLoading(true);
    try {
      await joinLinkApi.update(newLink.trim());
      alert("✅ Chapter Join Link updated successfully!");
      setNewLink("");
      fetchLink();
    } catch (err) {
      console.error("❌ Update failed:", err);
      alert("Failed to update link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-join-link-wrapper">
      <div className="admin-panel-header">
        <div className="panel-title-group">
          <i className="fas fa-link title-icon"></i>
          <div>
            <h2>Chapter Membership Join Link</h2>
            <p className="panel-subtitle">
              Target Google Form / Registration link when visitors click 'Join Chapter' on the main site
            </p>
          </div>
        </div>
      </div>

      <div className="join-link-vertical-stack">
        {/* Current Active Destination Card */}
        <div className="join-destination-card">
          <div className="destination-header">
            <span className="card-badge-label">
              <i className="fas fa-satellite-dish"></i> Current Active Destination
            </span>
            {link && (
              <a
                href={link}
                target="_blank"
                rel="noreferrer"
                className="external-preview-link"
              >
                <i className="fas fa-external-link-alt"></i> Test Live Link
              </a>
            )}
          </div>

          <div className="link-preview-box">
            <i className="fas fa-globe link-ic"></i>
            {link ? (
              <a
                href={link}
                target="_blank"
                rel="noreferrer"
                className="active-link-text"
                title={link}
              >
                {link}
              </a>
            ) : (
              <span className="no-link-text">No membership link currently configured</span>
            )}
          </div>
        </div>

        {/* Update Destination URL Form */}
        <div className="join-update-card">
          <form onSubmit={handleUpdate} className="join-inline-form">
            <div className="admin-form-group flex-grow">
              <label>
                <i className="fas fa-edit"></i> Update Destination URL
              </label>
              <div className="input-action-row">
                <input
                  type="url"
                  placeholder="https://docs.google.com/forms/d/e/..."
                  value={newLink}
                  onChange={(e) => setNewLink(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  className="admin-btn-primary save-link-btn"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <i className="fas fa-circle-notch fa-spin"></i> Saving...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save"></i> Save New Join Link
                    </>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminJoinLink;
